module.exports = new __parcel__URL__("BrickfilmDay.e6b7af40.jpeg").toString();